import { useCallback, useRef, useState } from "react";

export function useScrollGate() {
  const elRef = useRef<HTMLDivElement | null>(null);
  const observeRef = useRef<ResizeObserver | null>(null);
  const [hasRead, setHasRead] = useState(false);

  const check = useCallback(() => {
    const el = elRef.current;
    if (!el) return;
    const scrollable = el.scrollHeight > el.clientHeight + 8;
    if (!scrollable) return setHasRead(true);
    if (el.scrollHeight - el.scrollTop - el.clientHeight <= 8) setHasRead(true);
  }, []);

  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      observeRef.current?.disconnect();
      elRef.current = node;
      if (!node) return;
      check();
      observeRef.current = new ResizeObserver(check);
      observeRef.current.observe(node);
    },
    [check]
  );

  return { ref, elRef, hasRead, onScroll: check };
}
